/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GrantConsentRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {ConsentDecisionResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const grantConsent = (request: GrantConsentRequest, options?: CashRequestOptions) => post<GrantConsentRequest, ConsentDecisionResponse>("/2.0/cash/grant-consent", request, {...options, rejectOnError: true })